import PropTypes from 'prop-types'
import classNames from 'classnames'

import Select from './Select'

import chipClasses from '../OrganizationChips.module.scss'

const MultiValue = ({ data, innerProps, removeProps }) => (
  <span {...innerProps} className={classNames(chipClasses.chip, chipClasses.selectedChip, 'd-inline-flex align-items-center')}>
    <i className='fa fa-users' aria-hidden='true' />
    {data.label}
    <span {...removeProps} className={chipClasses.remove} role='button' tabIndex={0}>
      <i className='fa fa-times' aria-hidden='true' />
    </span>
  </span>
)

MultiValue.propTypes = {
  data: PropTypes.shape({ label: PropTypes.string.isRequired }).isRequired,
  innerProps: PropTypes.object,
  removeProps: PropTypes.object,
}

const OrganizationsSelect = ({ inputId, organizations, selectedIds, onChange, placeholder, noOptionsMessage, error }) => {
  const options = organizations.map(o => ({ value: o.id, label: o.name }))

  return (
    <Select
      inputId={inputId}
      isMulti
      value={options.filter(o => selectedIds.includes(o.value))}
      onChange={(selected) => onChange((selected || []).map(o => o.value))}
      options={options}
      placeholder={placeholder}
      noOptionsMessage={() => noOptionsMessage}
      components={{ MultiValue }}
      error={error}
    />
  )
}

OrganizationsSelect.propTypes = {
  inputId: PropTypes.string,
  organizations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  noOptionsMessage: PropTypes.string,
  error: PropTypes.arrayOf(PropTypes.string),
}

export default OrganizationsSelect
